"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_FUNCTION_CALL_GAS = void 0;
var utils_1 = require("@near-js/utils");
Object.defineProperty(exports, "DEFAULT_FUNCTION_CALL_GAS", { enumerable: true, get: function () { return utils_1.DEFAULT_FUNCTION_CALL_GAS; } });
